import { render, staticRenderFns } from "./Regulations.vue?vue&type=template&id=db3d609c&"
import script from "./Regulations.vue?vue&type=script&lang=ts&"
export * from "./Regulations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports